export const fastApiEndpoints = {
  conversation: {
    userConversations: {
      url: '/v0/conversations',
    },
    conversationById: (id) => ({
      url: `/v0/conversations/${id}`,
    }),
    conversationQuery: {
      url: '/v0/chat',
    },
    chatResume: {
      url: '/v0/chat/resume',
    },
    newAgentConversations: {
      url: '/v0/conversation',
    },
    newAgentConversationById: (id) => ({
      url: `/v0/conversation/${id}`,
    }),
  },
  image: {
    list: {
      url: '/v0/image',
    },
    search: {
      url: '/v0/image/search',
    },
  },
  assist: {
    stream: (thread_id) => ({
      url: `/v0/assist/${thread_id}/stream`,
    }),
    commandsResume: (thread_id) => ({
      url: `/v0/assist/${thread_id}/commands/resume`,
    }),
    commandsGoto: (thread_id) => ({
      url: `/v0/assist/${thread_id}/commands/goto`,
    }),
  },
};
